class ProductCardViewToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-media-index]') : null;
    if (!(btn instanceof HTMLButtonElement)) return;

    const index = Number.parseInt(btn.dataset.mediaIndex ?? '', 10);
    if (Number.isNaN(index)) return;
    const card = this.closest('product-card');
    const roomOverlay = card?.querySelector('.plp-room-image');
    const view = index === 1 ? 'room' : 'product';

    if (roomOverlay) {
      card?.setAttribute('data-card-media-view', view);
    } else if (card) {
      /** @type {import('./slideshow').Slideshow | null} */
      const slideshow = card.querySelector('slideshow-component');
      slideshow?.select(index);
    }

    this.querySelectorAll('[data-media-index]').forEach((b) => {
      const isActive = b === btn;
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      b.classList.toggle('card-view-toggle__btn--active', isActive);
    });
  };
}

if (!customElements.get('product-card-view-toggle')) {
  customElements.define('product-card-view-toggle', ProductCardViewToggle);
}
